<button type="button" class="custella-ed-button p-0"id="btn_AgAccessClone" (click)="onClick($event, 'clone')" [title]="translate?.general.buttons.clone.singular">
    <i class="fa-regular fa-clone"></i>
</button>
<button type="button" class="custella-ed-button p-0" id="btn_AgAccessEdit" [disabled]="!this.permissions?.update" (click)="onClick($event, 'edit')" [title]="translate?.general.buttons.edit.singular" *ngIf="showButton">
    <i class="fa-regular fa-pen"></i>
</button>
<button type="button" class="custella-del-button p-0"  id="btn_AgAccessDelete" [disabled]="!this.permissions?.remove" (click)="onClick($event, 'delete')" [title]="translate?.general.buttons.delete.singular" *ngIf="showButton">
    <i class="fa-regular fa-trash"></i>
</button>
